import Error from './error'

function InternalError({ statusCode }) {
  return (
    <Error
      errorMessage="Error del Servidor"
      status={statusCode || '(500)'}
      description="¡Ups! lo sentimos, hubo algunos problemas técnicos al procesar su solicitud."
      internal
    />
  )
}

export default InternalError
